"use client";

import { usePathname } from "next/navigation";
import { useEffect } from "react";

const ENTER_DURATION_MS = 800;

/**
 * Escuta mudanças de pathname e finaliza a transição "macOS Spaces":
 * remove a classe `gk-page-leaving-*` que ficou no body, aplica a
 * `gk-page-entering-*` que o helper deixou no `html.dataset.pageEntering`,
 * e remove ela após a animação. Sem o pisco entre slide-out e mount
 * da nova rota.
 */
export function PageTransitionManager() {
  const pathname = usePathname();

  useEffect(() => {
    const html = document.documentElement;
    const body = document.body;
    const enterCls = html.dataset.pageEntering;

    body.classList.remove("gk-page-leaving-left", "gk-page-leaving-right");

    if (!enterCls) return;

    delete html.dataset.pageEntering;
    body.classList.add(enterCls);

    const timeout = window.setTimeout(() => {
      body.classList.remove(enterCls);
    }, ENTER_DURATION_MS);

    return () => {
      window.clearTimeout(timeout);
      body.classList.remove(enterCls);
    };
  }, [pathname]);

  return null;
}
